import { Footer } from './components/layout/Footer/Footer';
import { Topbar } from './components/layout/Topbar/Topbar';
import { SoonModalProvider } from './components/ui/SoonModal/SoonModalContext';
import { FeatureSplits } from './components/sections/FeatureSplits/FeatureSplits';
import { Graduates } from './components/sections/Graduates/Graduates';
import { CallToAction } from './components/sections/CallToAction/CallToAction';
import { Hero } from './components/sections/Hero/Hero';
import { HowItWorks } from './components/sections/HowItWorks/HowItWorks';
import { ProblemSolution } from './components/sections/ProblemSolution/ProblemSolution';
import { Projects } from './components/sections/Projects/Projects';

function App() {
  return (
    <SoonModalProvider>
      <div className="page">
        <Topbar />
        <main>
          <Hero />
          <ProblemSolution />
          <HowItWorks />
          <FeatureSplits />
          <Graduates />
          <Projects />
          <CallToAction />
          <Footer />
        </main>
      </div>
    </SoonModalProvider>
  );
}

export default App;
